import useBriefContext from '../../../../../Hooks/Brief/useBriefContext'
import captureMessage from '../../../../../Utilities/Errors/captureMessage'
import ATTRIBUTES_BY_EVENT_TYPE from '../../../EventType/Logic/attributesByEventType'

const PageHeading = (): JSX.Element => {
  const {
    brief: { collectionName },
  } = useBriefContext()

  if (!collectionName) throw new Error('Missing event type in type-specific page heading component')
  const typeAttrs = ATTRIBUTES_BY_EVENT_TYPE[collectionName]

  if (!typeAttrs) {
    captureMessage(
      `Missing 'GuestNumberInput' attrs for event type ${collectionName} in page heading component`
    )
  }

  const titlePrefix = typeAttrs?.guestHeadingPrefix ?? 'Great!'

  return <>{`${titlePrefix} Who's invited?`}</>
}

export default PageHeading
